import { apiRequest } from '@/shared/api/client'
import type { FrontendUser } from '@/shared/types/api'

export type AuthSession = {
  authenticated: boolean
  user: FrontendUser | null
  csrf_token: string
}

export function getAuthSession() {
  return apiRequest<AuthSession>('/api/session', { includeTimezone: false })
}
